export default {
      id: "schedules-usage",
      viewBox: "0 0 33.25 33.25",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#schedules",
      toString: function () {
        return this.url;
      }
    }